import { createApiQueryHook, type IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { IGroupCorrectionItem } from "../types";

export type IGroupCorrectionQueryParameters = {
    groupCorrection?: RelationalValue<IGroupCorrectionItem>;
};

export type IGroupCorrectionResult = IGroupCorrectionItem;

export const groupCorrectionQuery: IApiQueryFunction<IGroupCorrectionQueryParameters> = ({ groupCorrection }) => {
    if (!groupCorrection) {
        return;
    }

    return {
        method: "GET",
        url: `/group_corrections/${mapRelationalValue(groupCorrection)}`,
    };
};

export const useGroupCorrectionQuery = createApiQueryHook<IGroupCorrectionQueryParameters, IGroupCorrectionResult>(
    groupCorrectionQuery,
);
